<div id="bookmark-know-overlay" class="left-overlay bgc-glass" [ngStyle]="overlayStyles">
  <p class="larger-font">
    We're here for you every step of the way, <b class="brand-primary-navy">{{ userName }}.</b>
  </p>
  <p class="larger-font">
    Have a question? Ask our
    <a
      class="overlay-link"
      (click)="onLinkClick()"
      target="_blank"
      href="https://orchestrators.genesys.com/home?product=genesys-cloud-cx">
      AI digital assistant
    </a>
    anything after signing into Genesys Orchestrators.
  </p>
</div>
